import OrdersContainer from './orders-container';

export default OrdersContainer;
